import type { AuthRepository } from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';
import { uuidValueObject } from '@contexts/shared/domain';

export type UnlockUserInput = {
	id: string;
};

export type UnlockUserUseCase = UseCase<UnlockUserInput, void>;

export function unlockUserBuilder(authRepository: AuthRepository): UnlockUserUseCase {
	return async function unlockUser(input: UnlockUserInput): Promise<void> {
		const id = uuidValueObject().validate('id', input.id);

		await authRepository.unlockUser(id);
	};
}
